export enum AutomationCanvasFilter {
  OBJECTS = 'automationObjects',
  RECORD_TYPES = 'automationRecordTypes',
  STEPS = 'automationSteps',
  ACTIONS = 'automationActions',
  OPERATIONS = 'automationOperations',
  DEPLOYMENT_REQUEST = 'automationDeploymentRequest',
  ACTIVE = 'automationActive',
}
